'use client';

import { Spacing } from '@ghosts-inc/design-system/constants';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@/components/Link';
import { GHOST_COIN_URL } from '@/constants/ghostCoinUrl';

export const TermsAndConditionsContent = ({ userName }: { userName?: string | null }) => {
  return (
    <Stack
      maxWidth={800}
      width="100%"
      alignItems="center"
      gap={{ mobile: Spacing.large, tablet: Spacing.xxlarge }}
      mb={{ mobile: Spacing.small, smallTablet: Spacing.xlarge }}
    >
      <Box width={{ mobile: 120, tablet: 140 }} minHeight={{ mobile: 120, tablet: 140 }}>
        <img src={GHOST_COIN_URL} alt="Ghost Coin" width="100%" />
      </Box>
      <Typography variant="h1" color="typographyDarkPrimary" textAlign="center" maxWidth={500}>
        We have updated our Terms and Conditions
      </Typography>
      <Box>
        <Typography variant="bodyLargeLight" mb={2}>
          {userName ? `Hi ${userName},` : 'Hi,'}
        </Typography>
        <Typography variant="bodyLargeLight" mb={2}>
          We are updating our Terms of Service, and we want to make sure you understand what it
          means for you as a customer at Ghost.
        </Typography>
        <Typography variant="bodyLargeLight">Key updates to note:</Typography>
        <List sx={{ pl: 2.5, pt: 0, listStyleType: 'decimal', mb: 2 }}>
          <Typography variant="bodyLargeLight" component="li">
            We have standardized our payment terms for buyers and sellers without existing payment
            agreements.
          </Typography>
          <Typography variant="bodyLargeLight" component="li">
            We require our customers to stay on the platform. All transactions with Ghost-introduced
            sellers must occur on Ghost. Off-platform deals are a direct violation of terms.
          </Typography>
          <Typography variant="bodyLargeLight" component="li">
            Any orders completed on Ghost are legally binding. Backing out by either party may
            result in enforcement action.
          </Typography>
        </List>
        <Typography variant="bodyLargeLight" mb={2}>
          These changes are designed to provide our buyers and sellers with a seamless, reliable
          experience that strengthens trust across our platform. You can review the full terms{' '}
          <Link href="https://ghst.io/terms-of-use" target="_blank">
            here
          </Link>
          . Please sign by{' '}
          <Typography component="span" variant="bodyLargeHeavy">
            June 30, 2025
          </Typography>{' '}
          in order to continue making purchases at Ghost.
        </Typography>

        <Typography variant="bodyLargeLight">Thanks for choosing to partner with Ghost.</Typography>
      </Box>
    </Stack>
  );
};
